import React from 'react';
import { ArrowRight } from 'lucide-react';

const DEALS = [
  {
    amount: '₹18 Cr', type: 'Working Capital Facility', sector: 'Mid-Market Manufacturing Company', state: 'Maharashtra',
    requirement: 'Seasonal raw-material buying strained existing cash-credit limits; single-bank pricing had drifted well above market.',
    solution: 'Enhanced cash credit blended with a working capital demand loan, assessed on the true operating cycle and placed in parallel across four banks.',
    outcome: 'Limits enhanced ~60% with meaningfully improved pricing.'
  },
  {
    amount: '₹42 Cr', type: 'Lease Rental Discounting', sector: 'Commercial Real Estate Business', state: 'Mumbai',
    requirement: 'Promoter equity locked in a leased commercial asset while a new acquisition opportunity had a closing deadline.',
    solution: 'LRD facility against escrowed rentals from marquee tenants, tenor matched to lease terms, with competitive term sheets from three institutions.',
    outcome: 'Facility structured within the acquisition timeline.'
  },
  {
    amount: '₹95 Cr', type: 'Project Finance', sector: 'Renewable Energy Developer', state: 'Rajasthan',
    requirement: 'Greenfield solar project required long-tenor debt with a limited-recourse structure acceptable to sponsors.',
    solution: 'Senior project debt with DSRA and receivable escrow aligned to PPA cash flows, syndicated across a lead bank and co-lender.',
    outcome: 'Financial closure achieved; disbursement aligned to construction milestones.'
  }
];

export const CaseStudies = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-24 bg-slate-50" data-testid="case-studies">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4 uppercase tracking-wide">
            Structured. Placed. <span className="text-emerald-600">Closed.</span>
          </h2>
          <p className="text-lg text-slate-600">Selected financing situations from our advisory mandates</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {DEALS.map((d) => (
            <div
              key={d.amount}
              className="bg-white rounded-xl border border-slate-200 border-t-4 border-t-emerald-600 hover:shadow-[0_4px_16px_rgba(15,23,42,0.08)] transition-all duration-300 p-8"
              data-testid={`case-study-${d.amount.replace(/[^0-9]/g, '')}`}
            >
              <p className="text-2xl font-bold text-slate-900">{d.amount} <span className="font-semibold text-slate-700">{d.type}</span></p>
              <p className="mt-1.5 text-xs uppercase tracking-wider text-slate-500">{d.sector} · {d.state}</p>
              <dl className="mt-6 space-y-4">
                {[['Requirement', d.requirement], ['Solution', d.solution], ['Outcome', d.outcome]].map(([k, v]) => (
                  <div key={k} className="border-t border-slate-100 pt-3">
                    <dt className="text-xs uppercase tracking-wider font-bold text-emerald-700">{k}</dt>
                    <dd className="mt-1 text-sm text-slate-600 leading-relaxed">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 max-w-6xl mx-auto">
          <button
            onClick={scrollToContact}
            className="inline-flex items-center gap-2 text-emerald-700 font-semibold text-sm hover:gap-3 transition-all"
            data-testid="case-study-discuss-btn"
          >
            Discuss a similar requirement <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
